import React from 'react'
import { connect } from 'react-redux'
import { icons } from '../../../constants'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import { Page } from '../../../components/page/Page'
import { actions } from '../parametro.actions'
import utils from '../../../utils/index'
import { ParametroForm } from './ParametroForm'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import storage from '../../../services/stoage.service'
import { logarAcesso } from '../../../services/api-log-acesso'
import { messageActions } from '../../../store/message'
import { ConfirmarRemocaoParametro } from '../../../components/parametros/ConfirmarRemocaoParametro'
import {
  ACAO_SALVAR,
  acaoAoSalvar,
  comNomeParaGravar,
  isNomeEmUso,
  isNomeVazio,
  isSemValorParaSigilosa,
  isSigilosaDisponivel,
  podeRemover,
  prepararEdicao,
} from '../../../utils/credencialMascarada'

const mapStateToProps = (state) => {
  const currentCompany = storage.getCompany()
  let unidades = utils.getListIdValuesUnidadeFromEmpresa(currentCompany)

  return {
    columns: state.crudParametroState.columns,
    messages: state.crudParametroState.messages,
    parametros: state.crudParametroState.currentRecord.parametros,
    records: state.crudParametroState.records,
    unidades,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    load: (oidUnidade) => dispatch(actions.loadKeys(oidUnidade)),
    setRecords: (parametros) => dispatch(actions.setRecords(parametros)),
    deleteKey: (oidUnidade, key) => dispatch(actions.deleteKey(oidUnidade, key)),
    updateKey: (oidUnidade, key, value, recarregar, sigilosa) =>
      dispatch(actions.updateKey(oidUnidade, key, value, recarregar, sigilosa)),
    showError: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'error')),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
  }
}

class ParametroFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      permissoes: utils.getPermissoesPorMenu(
        storage.getMenus(),
        storage.getOidCurrentMenu(),
        null,
        storage.getPortalCliente()
      ),
      unidade: this.props.unidades[0],
    }
    actions.afterSave = () => {
      this.props.load(this.state.unidade.id)
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.load(this.state.unidade.id)
  }

  onChangeUnit = (e) => {
    const target = e.target
    let valor = target.value
    this.setState({ unidade: valor })

    this.props.load(valor.id)
  }

  saveParameter = () => {
    const { parametroAnterior, novoParametro } = this.state
    const parametro = comNomeParaGravar(this.state.parametro, parametroAnterior, novoParametro)
    if (isNomeVazio(parametro)) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosunidade.label.chaveObrigatoria'))
      return
    }
    if (isNomeEmUso(this.props.records, parametro, parametroAnterior, novoParametro)) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosunidade.label.nomeJaExiste'))
      return
    }
    // Sem mexer na grade antes da resposta: o valor digitado (credencial, inclusive) ficaria em claro na tela se o
    // recarregar falhasse. A grade vem do back, que devolve a credencial mascarada.
    if (novoParametro) {
      if (this.state.sigilosa) {
        this.salvarSigilosa(parametro)
        return
      }
      this.props.updateKey(this.state.unidade.id, parametro.id, parametro.value)
      this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
    } else {
      const acao = acaoAoSalvar(parametro, parametroAnterior, this.state.credencialMascarada)
      if (acao === ACAO_SALVAR.MANTER) {
        // Credencial nao alterada: o back nunca manda o valor real, entao nao ha o que reenviar.
        this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
        return
      }
      if (acao === ACAO_SALVAR.RENOMEAR_SEM_VALOR) {
        this.props.showError(utils.getMessage(this.props.messages, 'parametrosunidade.label.credencialRenomear'))
        return
      }
      const { unidade } = this.state
      const renomeado = parametro.id !== parametroAnterior.id
      // Renomeando, recarrega uma vez so, depois do delete: dois recarregamentos em paralelo podiam chegar fora de
      // ordem e mostrar a chave antiga ja apagada.
      this.props.updateKey(unidade.id, parametro.id, parametro.value, !renomeado).then((gravou) => {
        // Nome mudou: so depois de gravar com o nome novo apaga o antigo (antes ficavam os dois).
        if (gravou && renomeado) {
          // So recarrega se a unidade da tela ainda for a mesma: trocar de unidade no meio poria as chaves desta
          // na grade da outra (e editar ali gravaria na unidade errada).
          // Se o delete falhar, a action ja mostra o erro e recarrega a unidade da tela.
          this.props.deleteKey(unidade.id, parametroAnterior.id).then((removeu) => {
            if (removeu && this.state.unidade && this.state.unidade.id === unidade.id) {
              this.props.load(unidade.id)
            }
          })
        }
      })
      this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
    }
  }

  // "Sigilosa": o dialogo so fecha depois que o back confirma. Recusada (nome em uso, sem valor), o valor digitado continua
  // ali - fechar e reabrir convidaria a gravar a credencial sem marcar.
  salvarSigilosa = (parametro) => {
    if (isSemValorParaSigilosa(parametro)) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosunidade.label.sigilosaSemValor'))
      return
    }
    this.setState({ salvando: true })
    this.props.updateKey(this.state.unidade.id, parametro.id, parametro.value, true, true).then((gravou) => {
      // false = recusada, nada gravado: fica aberto. null = pode ter gravado (a grade ja recarregou): fecha, para nao
      // convidar a repetir uma gravacao que talvez ja tenha acontecido.
      if (gravou === false) {
        this.setState({ salvando: false })
      } else {
        this.setState({ salvando: false, parametroSelecionado: null, parametro: null, displayDialog: false })
      }
    })
  }

  // Remover apaga de verdade a chave SELECIONADA na lista (nao o nome digitado no campo) e, com a credencial
  // mascarada, o valor nao pode ser redigitado de memoria: pede confirmacao citando a chave.
  confirmarRemocao = () => {
    if (podeRemover(this.state)) {
      this.setState({ confirmarRemocao: true })
    }
  }

  buildDialogConfirmarRemocao = () => (
    <ConfirmarRemocaoParametro
      visible={this.state.confirmarRemocao}
      chave={this.state.parametroSelecionado ? this.state.parametroSelecionado.id : null}
      texto={utils.getMessage(this.props.messages, 'parametrosunidade.label.confirmarRemover')}
      confirm={this.delete}
      hideDialog={() => this.setState({ confirmarRemocao: false })}
    />
  )

  delete = () => {
    if (this.state.parametroSelecionado && this.state.parametroSelecionado.id) {
      let selectedKey = this.state.parametroSelecionado.id
      this.props.deleteKey(this.state.unidade.id, selectedKey)
      let index = this.findSelectedParameterIndex()
      let parametrosRestantes = this.props.records.filter((val, i) => i !== index)
      this.props.setRecords(parametrosRestantes)
    }
    this.setState({
      parametroSelecionado: null,
      parametro: null,
      displayDialog: false,
    })
  }

  findSelectedParameterIndex = () => {
    return this.props.records.indexOf(this.state.parametroSelecionado)
  }

  newHandler() {
    this.setState({
      parametro: { id: '', value: '' },
      displayDialog: true,
      novoParametro: true,
      credencialMascarada: false,
      sigilosa: false,
      salvando: false,
    })
  }

  resolveBotaoNovo() {
    if ((this.state.permissoes && this.state.permissoes.inserir) || !this.state.permissoes) {
      return (
        <Button
          onClick={(e) => this.newHandler(this)}
          label={utils.getMessage(this.props.messages, 'label.novo')}
          className="p-button-success"
          icon={icons.PLUS_ICON}
          style={{ marginRight: '.25em' }}
          disabled={this.state.unidade === undefined}
        />
      )
    }
    return null
  }

  updateProperty(property, value) {
    let parametro = this.state.parametro
    parametro[property] = value
    this.setState({ parametro: parametro })
  }

  onSelectionChange = (e) => {
    this.setState({ parametroSelecionado: e.value })
  }

  onParametroSelecionado = (e) => {
    const { parametro, credencialMascarada } = prepararEdicao(e.data)
    this.setState({
      displayDialog: true,
      parametro,
      parametroAnterior: Object.assign({}, e.data),
      novoParametro: false,
      credencialMascarada,
    })
  }

  buildDialog = () => {
    let dialogFooter = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button
          label={utils.getMessage(this.props.messages, 'label.remover')}
          icon="pi pi-times"
          disabled={!podeRemover(this.state)}
          onClick={this.confirmarRemocao}
        />
        <Button
          label={utils.getMessage(this.props.messages, 'label.salvar')}
          icon="pi pi-check"
          disabled={!!this.state.salvando}
          onClick={this.saveParameter}
        />
      </div>
    )
    return (
      <Dialog
        visible={this.state.displayDialog}
        width="300px"
        header="Parâmetros"
        modal={true}
        footer={dialogFooter}
        onHide={() => {
          // Esperando a "Sigilosa": fechar agora deixaria a resposta atrasada fechar o proximo dialogo aberto.
          if (!this.state.salvando) {
            this.setState({ displayDialog: false })
          }
        }}
        contentStyle={{ 'max-height': '500px' }}
      >
        {this.state.parametro && (
          <div className="p-grid p-fluid">
            <div className="p-col-4" style={{ padding: '.75em' }}>
              <label htmlFor="id">Key</label>
            </div>
            <div className="p-col-8" style={{ padding: '.5em' }}>
              <InputText
                id="id"
                onChange={(e) => {
                  this.updateProperty('id', e.target.value)
                }}
                value={this.state.parametro.id}
                disabled={!!this.state.salvando}
              />
            </div>

            <div className="p-col-4" style={{ padding: '.75em' }}>
              <label htmlFor="value">Value</label>
            </div>
            <div className="p-col-8" style={{ padding: '.5em' }}>
              <InputTextarea
                id="value"
                rows={1}
                cols={30}
                style={{ 'max-height': '450px' }}
                autoResize={true}
                onChange={(e) => {
                  this.updateProperty('value', e.target.value)
                }}
                value={this.state.parametro.value}
                disabled={!!this.state.salvando}
                placeholder={
                  this.state.credencialMascarada
                    ? utils.getMessage(this.props.messages, 'parametrosunidade.label.credencialPreenchida')
                    : undefined
                }
              />
            </div>

            {/* So no Novo: chave existente nao ganha a opcao, e desmarcar nao existe pela tela. */}
            {this.state.novoParametro &&
              isSigilosaDisponivel(
                utils.getMessage(this.props.messages, 'parametrosunidade.label.sigilosa'),
                utils.getMessage(this.props.messages, 'parametrosunidade.label.sigilosaDica')
              ) && (
                <React.Fragment>
                  <div className="p-col-4" style={{ padding: '.75em' }}>
                    <label htmlFor="sigilosa">
                      {utils.getMessage(this.props.messages, 'parametrosunidade.label.sigilosa')}
                    </label>
                  </div>
                  <div className="p-col-8" style={{ padding: '.5em' }}>
                    <Checkbox
                      inputId="sigilosa"
                      checked={!!this.state.sigilosa}
                      disabled={!!this.state.salvando}
                      onChange={(e) => this.setState({ sigilosa: e.checked })}
                    />
                    {this.state.sigilosa && (
                      <small style={{ display: 'block', marginTop: '.25em' }}>
                        {utils.getMessage(this.props.messages, 'parametrosunidade.label.sigilosaDica')}
                      </small>
                    )}
                  </div>
                </React.Fragment>
              )}
          </div>
        )}
      </Dialog>
    )
  }

  buildHeader = () => {
    return (
      <div>
        <div className="p-grid p-justify-start p-align-center">
          <h4>{utils.getMessage(this.props.messages, 'parametrosunidade.label.parametrosunidade')}</h4>
        </div>
        <div className="p-toolbar-group-left">{this.resolveBotaoNovo()}</div>
      </div>
    )
  }
  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      return <Column {...col} key={col.field} sortField={col.columnSortField} />
    })
  }

  buildContent = () => {
    return (
      <div>
        {this.buildDialog()}
        {this.buildDialogConfirmarRemocao()}
        <ParametroForm
          {...this.props}
          onSelectionChange={this.onSelectionChange}
          onParametroSelecionado={this.onParametroSelecionado}
          onPage={this.onPage}
          onSort={this.onSort}
          columns={this.defineColumns()}
          unidade={this.state.unidade}
          onChangeUnit={this.onChangeUnit}
        />
      </div>
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      return <Page header={this.buildHeader()} content={this.buildContent()} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParametroFormPageContainer)
